const ONE_SEC_IN_MS = 1000;
const ONE_MIN_IN_MS = 60 * ONE_SEC_IN_MS;

export const TIME = {
  ONE_SEC_IN_MS,
  ONE_MIN_IN_MS,
};
